import React from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import { setIsLoading } from "redux/loader/action";
import HeyLimeTerms from "shared/components/HeyLimeTerms";
import { ReactComponent as InvalidUrlSvg } from "assets/images/common/invalid-url.svg";

const InvalidURL = (props) => {
  const dispatch = useDispatch();
  const {
    paramsReducer: {
      paramsObj: { mobile_website: { signin: signin_params } = {} } = {}
    }
  } = useSelector((state) => state);

  const terms_text = _.get(
    signin_params,
    "terms_text",
    "By using HeyLime you Agree to our "
  );
  const terms_url = _.get(
    signin_params,
    "terms_url",
    "https://gameapart-config.s3.amazonaws.com/common/terms.html"
  );

  return (
    <div className="invalid-url">
      <div className="invalid-url-content">
        <InvalidUrlSvg />
        <h2>Page not Found</h2>
        <p>The page you are looking for is not available!</p>
        <button onClick={() => props.history.replace("/")}>
          Back to Homepage
        </button>
      </div>
      <HeyLimeTerms
        terms_url={terms_url}
        terms_text={terms_text}
        setIsLoading={(value) => dispatch(setIsLoading(value))}
      />
    </div>
  );
};

export default InvalidURL;
